import { Injectable } from '@angular/core';

import { StylesLazyLoadingService } from '../deferred/styles/style-loading.service';

@Injectable()
export class RacingStylesResolver {
    constructor(private stylesService: StylesLazyLoadingService) {}

    async resolve(): Promise<void> {
        return await this.stylesService.lazyLoad('racing');
    }
}
